<template>
  <div class="container" v-loading="loading">
    <!-- tab -->
    <div class="tabs-dialog" v-if="!userId">
      <div class="tabs">
        <div class="tab" v-for="(tab, index) in tabs" :key="index" @click="goTab(tab, index)">
          <div :class="activeIndex == index ? 'active' : ''" style="margin-right: 0.5rem">
            {{ tab.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 提交执行数据 -->
    <div v-if="userId || activeIndex === 1" @click="dialogVisible = true" class="save" type="primary">提交</div>

    <!-- 组件 -->
    <component ref="common" class="component" :userList="userList" :userId="userId" :is="component" @change="change"></component>
    <myDialog :dialogVisible="dialogVisible" question="是否确认提交(不包含未来时间点记录)" @close="dialogVisible = false" @setup="updateSave" dialogWidth="66%"></myDialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import myDialog from '@/common/dialog.vue'
import one from './one.vue'
import record from './record.vue'
import execute from './execute.vue'
export default {
  // 局部注册的组件
  components: {
    myDialog
  },
  // 组件状态值
  data() {
    return {
      activeIndex: 0,
      dialogVisible: false,
      loading: false,
      component: one,
      tabs: [
        {
          name: '治疗执行',
          components: one
        },
        {
          name: '批量执行',
          components: execute
        },
        {
          name: '历史记录',
          components: record
        }
      ],
      userList: {},
      userId: ''
    }
  },
  watch: {
    $route(to, from) {
      // 监听URL参数的变化
      if (to.query.id) {
        this.component = execute
        this.activeIndex = 0
      } else {
        this.userId = ''
        this.component = one
        this.activeIndex = 0
      }
    }
  },

  created() {
    this.getList()
  },

  // 组件方法
  methods: {
    // 获取数据
    getList() {
      this.loading = true
      this.$axios
        .post('/Pad/NoMedicineInformation')
        .then((res) => {
          this.loading = false
          this.userList = res.data.obj
        })
        .catch(() => {
          this.dataUpdate = false
          this.loading = false
        })
    },

    // 组件变化
    change(id) {
      this.$router.push({ path: '/cure', query: { id } })
      this.userId = id
      this.component = execute
    },

    // tab切换
    goTab(tab, index) {
      this.userId = ''
      this.activeIndex = index
      this.component = tab.components
    },

    //  执行提交
    updateSave() {
      if (this.$refs.common.list) {
        //IsCheck 记录是否已经执行
        let result = this.$refs.common.list.filter((item) => item.IsEdit)
        result = JSON.parse(JSON.stringify(result))
        // 如果未完成服药数量为空
        result = result.map((val) => {
          val.Amount = val.Value ? null : val.Amount
          return val
        })

        if (result.length) {
          if (result.find((val) => new Date(val.DTime).getTime() > new Date().getTime())) {
            this.$message({
              message: '不允许保存未来时间点的项目！',
              type: 'warning',
              customClass: 'custom-message'
            })
          } else {
            this.loading = true
            const params = {
              Items: result
            }
            const cUser = this.$store.state.user.UserName
            const userId = this.$store.state.user.UserId
            // 提交执行数据
            this.$axios
              .post(`/Pad/NoMedicalEditInformation?cUser=${cUser}&cUserId=${userId}`, params)
              .then((res) => {
                this.getList()
              })
              .catch(() => {
                this.loading = false
              })
          }
        } else {
          this.$message({
            message: '请先选择项目!',
            type: 'warning',
            customClass: 'custom-message'
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f7f8fa;
  box-sizing: border-box;
}
.tabs-dialog {
  position: relative;
  display: flex;
  align-content: center;
  justify-content: space-between;
  align-content: center;
  padding: 15px;
  background: #fff;
  width: 100%;
  height: 53px;
  margin: 0px auto;
  border-bottom: 1px solid #ebebeb;
  box-sizing: border-box;
}

.tabs {
  width: 100%;
  display: flex;
  font-size: 16px;
  font-weight: 510;
  color: #0a0e10;
}

.save {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 54px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 3px;
  border-color: #029fd1;
  background: #029fd1;
  font-size: 12px;
  color: #fff;
}
.tab {
  font-family: 'PingFang SC Medium';
  position: relative;
}
.active::after {
  position: absolute;
  top: 35px;
  left: 0px;
  content: '';
  width: 63px;
  height: 2px;
  background: #029fd1;
  display: block;
}
.tabs-dialog >>> .dialog-tips {
  width: 120px !important;
}

.component {
  flex: 1;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/cure/index.vue